import React from 'react'

// Fixed "DEMO REJIMI" badge so the showcase is never mistaken for a live
// system (ТЗ рекомендация №5). Non-interactive, always on top.
const style = {
	position: 'fixed',
	bottom: 16,
	right: 16,
	zIndex: 2000,
	background: '#ff4d4f',
	color: '#fff',
	fontWeight: 700,
	fontSize: 12,
	letterSpacing: '0.08em',
	padding: '6px 12px',
	borderRadius: 6,
	boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
	pointerEvents: 'none',
	userSelect: 'none',
}

const DemoBadge = () => <div style={style}>DEMO REJIMI</div>

export default DemoBadge
